import React from 'react';

import CartRequestIcon from '@components/common/CartRequestIcon/CartRequestIcon';

import { IIconProps, TIconType } from '../interface';

import ListWhiteIcon from './ListWhiteIcon';

const RequestCartActiveIcon: TIconType = (props?: IIconProps) => {
	return (
		<CartRequestIcon
			counter={props?.count}
			icon={ListWhiteIcon(props)}
		/>
	);
};

export default RequestCartActiveIcon;
